<template>
          <!-- contents -->
          <div id="contents">
            <div class="contents_wrap">
              <!-- contents_head -->
              <!-- breadcrumbs -->
              <skp-breadcrumbs @page-title="val => pageTitle = val" />
              <!-- //breadcrumbs -->
              <h2 class="pg_title">{{ pageTitle }}</h2>
              <!-- //contents_head -->

              <!-- srchTop_wrap -->
              <div class="srchTop_wrap">
                <article class="srch_basic">
                  <div class="srch_grup">
                    <ul class="w50">
                      <li class="tit_150">Subsidiary</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select id="selectRhqCd1" name="selectRhqCd1" v-model="selectRhqCd" @change="changeRhqCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqCd ? (item.code == selectRhqCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select id="selectRhqSubCd1" name="selectRhqSubCd1" v-model="selectRhqSubCd" @change="changeRhqSubCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqSubCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqSubCd ? (item.code == selectRhqSubCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>
                                    
                    <ul class="w50">
                      <li class="tit_150">Content Type</li>
                      <li data-input-type="select" class="w100-150">
                        <select id="selectContentType" name="selectContentType" v-model="selectContentType" class="slt_white w100">
                            <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                            <option VALUE='SM'>Service Manual</option>
                            <option VALUE='KSML'>Local Service Manual</option>
                            <option VALUE='EV'>Exploded View</option>
                            <option VALUE='SB'>Service Bulletin</option>
                            <option VALUE='KSBL'>Local Service Bulletin</option>
                            <option VALUE='IG'>Install Guide</option>
                            <option VALUE='TM'>Training Manual</option>
                            <option VALUE='KTTM'>Technical Training Manual</option>
                            <option VALUE='KATM'>Agent Technical Manual</option>
                            <option VALUE='RT'>Repair Tip</option>
                            <option VALUE='KRRT'>Repeated Repair Tip</option>
                            <option VALUE='KRTT'>Local Repair Tip</option>
                            <option VALUE='DR'>Driver</option>
                            <option VALUE='FM'>Firmware</option>
                            <option VALUE='SW'>Software</option>
                            <option VALUE='UM'>User Manual</option>
                            <option VALUE='EM'>Quick Guide</option>
                            <option VALUE='AT'>Agent Tip</option>
                            <option VALUE='KAGT'>Local Agent Tip</option>
                            <option VALUE='CS'>Consult Script</option>
                        </select>
                      </li>
                    </ul>
                    <ul class="w100">
                      <li class="tit_150">Category</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select class="slt_white w100p"
                                    id="PRD_CATEGORY_CD1"
                                    v-model="PRD_CATEGORY_CD1"
                                    @change="changeCategory1($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList1.length > 0"
                                        v-for="item in categoryComboList1"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select class="slt_white w100p"
                                    id="PRD_CATEGORY_CD2"
                                    v-model="PRD_CATEGORY_CD2"
                                    @change="changeCategory2($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList2.length > 0"
                                        v-for="item in categoryComboList2"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select class="slt_white w100p"
                                    id="PRD_CATEGORY_CD3"
                                    v-model="PRD_CATEGORY_CD3"
                                    @change="changeCategory3($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList3.length > 0"
                                        v-for="item in categoryComboList3"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">
                            Registered period <em class="txt_mandatory">*</em>
                        </li>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="knowledge_fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                        <a href="javascript:" class="in_btn" id="knowledge_icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="knowledge-from-picker-container" style="margin-top: -1px;"></div>
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="knowledge_toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                        <a href="javascript:" class="in_btn" id="knowledge_icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="knowledge-to-picker-container" style="margin-top: -1px;"></div>
                                </span>
                            </fieldset>
                        </dd>
                    </ul>      
                    <ul class="w50">
                        <li class="tit_150">
                            Counting Period <em class="txt_mandatory">*</em>
                        </li>
                        <li data-input-type="date" class="w100-150">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="view_fromDate" type="text" placeholder="From Date" class="date_input w100p" readonly>
                                        <a href="javascript:" id="view_icoFromDate" class="in_btn">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">Counting Period</span>
                                        </a>
                                    </label>
                                    <div id="view-from-picker-container" style="margin-top: -1px;" />
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="view_toDate" type="text" placeholder="To Date" class="date_input w100p" readonly>
                                        <a href="javascript:" id="view_icoToDate" class="in_btn">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">Counting Period</span>
                                        </a>
                                    </label>
                                    <div id="view-to-picker-container" style="margin-top: -1px;" />
                                </span>
                            </fieldset>
                        </li>
                    </ul>      
                    
                    <!-- <ul class="w100">
                      <li class="tit_150">Keyword</li>
                      <li data-input-type="select" class="w100-150">
                        <div class="sel_input">
                          <select class="slt_white" id="subJectType" v-model="SUBJECT_TYPE">
                            <option value="S">Subject</option>
                            <option value="R">Register by</option>
                          </select>
                          <span class="clearable">
                            <input
                              type="text"
                              class="text_input"
                              id="subJect" 
                              v-model="SUBJECT"
                              v-clearable @keyup.enter.stop="search(1)"
                              style="position: relative;"
                              placeholder="Enter subject with less than 90 characters"
                              v-clearable
                            />
                            <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                          </span>
                        </div>
                      </li>
                    </ul> -->
                  </div>
                  <div class="srch_grupR_bottom">
                    <span class="btn">
                      <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                    </span>
                  </div>
                </article>
              </div>
              <!-- Grid -->
              <!-- Grid -->
              <div class="grid_wrap number-cell">
                    <!-- Count -->
                <!-- <div class="grid_total">
                    Total&nbsp;Count&nbsp;
                    <em>{{ totalCount | numberFormat }}</em>
                </div> -->
                <div class="btn_wrap">
                    <a
                            href="javascript:"
                            class="btn_white"
                            @click="excelDownload()"
                            title
                        >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    ref="GridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :key="gridKey"
                    :header="header"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>

            <!-- <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="search"
                    align="center"
                />
             </div> -->
            </div>
          </div>
          <!-- contents -->

</template>

<script>
import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import qs                                   from 'query-string';
import axios                                from 'axios';
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, MenuUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';


import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import DatePicker                           from '~c/DatePicker';
import ToastGrid                            from '~c/ToastGrid';

import ExcelDownloadPopup                   from '~vb/common/ExcelDownloadPopup';


import KnowledgeCategoryPop              from '~va/statisticsManager/KnowledgeCategoryPop.vue';


// java to moment dateformat parser
require('moment-jdateformatparser');

const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/statisticsManagerContentsSatisfactionNewList.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'recommendationContentsList',
    props : {

    },
    data() {
        return {
            isProcess: true,

            selectRhqCd: '',
            selectRhqNm: '',
            selectRhqSubCd: '',
            selectRhqSubNm: '',

            rhqCdList: [],
            rhqSubCdList: [],

            selectContentType:'',
            selectProperty:'',

            PRD_CATEGORY_CD1: '',   // Category 1
            PRD_CATEGORY_CD2: '',   // Category 2
            PRD_CATEGORY_CD3: '',   // Category 3
            categoryComboList1: [], // Category 1 List
            categoryComboList2: [], // Category 2 List
            categoryComboList3: [], // Category 3 List
            knowledgeRangePicker: null,
            viewRangePicker: null,

            KNOWLEDGE_FROM_DATE:{},
            KNOWLEDGE_TO_DATE: {},     // Knowledge date
            VIEW_FROM_DATE:{},
            VIEW_TO_DATE: {},       // View date

            SORTBY : "S",

            SUBJECT_TYPE: 'S',
            SUBJECT: '',

            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "GridId",
            gridKey: 0,
            gridData : [],
            header: {
                height: 80,
                complexColumns: [
                    {
                        header: 'Satisfaction',
                        name: 'mergeColumn1',
                        childNames: ['HELPFUL_CNT', 'UNHELPFUL_CNT', 'SCORE']
                    },
                ]
            },
            columns : [
                
                {
                    header: "Category",
                    name: "CATEGORY_NM_CNV",
                    //width: 250,
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
               
                {
                    header: "Helpful",
                    name: "HELPFUL_CNT",
                    align: "right",
                    width: 100,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Unhelpful",
                    name: "UNHELPFUL_CNT",
                    align: "right",
                    width: 100,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Score(%)",
                    name: "SCORE",
                    align: "right",
                    width: 100,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Views",
                    name: "VIEW_CNT",
                    align: "right",
                    width: 100,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "KNOWLEDGE_FROM_DATE",
                    name: "KNOWLEDGE_FROM_DATE",
                    hidden: true,
                },
                {
                    header: "KNOWLEDGE_TO_DATE",
                    name: "KNOWLEDGE_TO_DATE",
                    hidden: true,
                },
                {
                    header: "VIEW_FROM_DATE",
                    name: "VIEW_FROM_DATE",
                    hidden: true,
                },
                {
                    header: "VIEW_TO_DATE",
                    name: "VIEW_TO_DATE",
                    hidden: true,
                },
                {
                    header: "CORP_NO",
                    name: "CORP_NO",
                    hidden: true,
                },
                {
                    header: "CONTENT_CD",
                    name: "CONTENT_CD",
                    hidden: true,
                },
                {
                    header: "CATEGORY_CD",
                    name: "CATEGORY_CD",
                    hidden: true,
                },
                
            ],
            options : {
                scrollX: true,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            userRoles:  'getRoles',
            userCorpCd: 'getCorpCd',
            params:     'getParams',
            locale:     'getLocale',
            menus:      'getMenus',
            loginNo:    'getLoginNo',
            loginRhq:   'getLoginRhq'
        }),
        getDateformat() {
            return localStorage.getItem('mDateFormat');
        },
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getLoginRHQCd() {
            return this.loginRhq || '';
        },
        getLoginCompanyCd() {
            return this.userCorpCd || '';
        },
        getLoginNo() {
            return this.loginNo || '';
        },
        getUserRole() {
            return this.userRoles || '';
        },


    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        
        categoryClear(){
            this.setCategory1();
            this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
            this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
        },
        async getCodeComboList(categoryVal, categoryCode) {
            let corpCd = this.selectRhqSubCd == "" ? this.getUserCorpCd : this.selectRhqSubCd;
            const codeResp = await api.getComboList(categoryVal, categoryCode, corpCd);
            return codeResp;
        },
        async getCodeComboList1(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.rhqSubCdList = [], this.selectRhqSubCd = '';

            } else {
                this.getCodeComboList1(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = '';
                });
            }
            this.categoryClear();
        },
        // 법인 코드 변경 이벤트
        changeRhqSubCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.selectRhqSubCd = '';
                this.selectRhqSubNm = '';
            } else {
                this.selectRhqSubCd = this.getComboBoxVal(e.target.id);
                this.selectRhqSubNm = this.getComboBoxName(e.target.id);
            }
            this.categoryClear();
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.PRD_CATEGORY_CD1 = "";
                this.categoryComboList1 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1() {
            if(this.PRD_CATEGORY_CD1 == "") {
                this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(this.PRD_CATEGORY_CD1, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2 = '';
                    this.categoryComboList2 = data;
                });

                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2() {
            if(this.PRD_CATEGORY_CD2 == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(this.PRD_CATEGORY_CD2, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3 = '';
                    this.categoryComboList3 = data;
                });
            }
        },
        // 세번째 카테고리 변경 이벤트
        async changeCategory3() {
            if(this.PRD_CATEGORY_CD3 == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },

        // 권한체크
        isAllUser(){
            
            if(this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`) || 
               this.getUserRole.includes(`${constants.GBM_ADMIN}`) ||
               this.getUserRole.includes(`${constants.RHQ_ADMIN}`)) 
            {
                return true;
            }else{
                return false;
            }
            
        },

        // 버튼 이벤트
        async search(pageNo) {
            let validContents = this.registVerifyContents();
            if (validContents) {
                if (!pageNo) pageNo = 1;
                const mFormat = localStorage.getItem('mDateFormat');
                let params = {
                    page                : pageNo,
                    RHQCD               : this.selectRhqCd,
                    RHQSUBCD            : this.selectRhqSubCd,
                    CONTENTTYPE         : this.selectContentType,
                    PROPERTY            : this.selectProperty,
                    PRD_CATEGORY_CD1    : this.PRD_CATEGORY_CD1,
                    PRD_CATEGORY_CD2    : this.PRD_CATEGORY_CD2,
                    PRD_CATEGORY_CD3    : this.PRD_CATEGORY_CD3,
                    KNOWLEDGE_FROM_DATE : this.knowledgeRangePicker.getStartDate() ? moment(this.knowledgeRangePicker.getStartDate()).format(mFormat) : '',
                    KNOWLEDGE_TO_DATE   : this.knowledgeRangePicker.getEndDate() ? moment(this.knowledgeRangePicker.getEndDate()).format(mFormat) : '',
                    VIEW_FROM_DATE      : this.viewRangePicker.getStartDate() ? moment(this.viewRangePicker.getStartDate()).format(mFormat) : '',
                    VIEW_TO_DATE        : this.viewRangePicker.getEndDate() ? moment(this.viewRangePicker.getEndDate()).format(mFormat) : ''
                };

                SDLUtil.showLoadingBar(true);
                const response = await fetchGridData(params)
                    .then(res => {
                        let data = res.data;
                        this.totalCount = data.count;
                        this.gridData = data.rows;
                        this.gridKey++;
                        this.currentPage = pageNo;
                        this.$nextTick(() => {
                            let idx = 0;    
                            for(let row of this.gridData){
                                if(row.CATEGORY_NM_CNV.indexOf("Total") >= 0 ) {
                                    this.$refs.GridId.addRowClassName(idx, 'sub_total');
                                }else{
                                    this.$refs.GridId.addRowClassName(idx, 'cur_pointer');
                                }
                                idx++;
                            }
                        });
                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        // 컨텐츠 클릭 이벤트 -> KnowledgeListGrid
        contentClick(e, rowData, grid) {

            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData[e.rowKey];
            let knowledgeFromDate = row['KNOWLEDGE_FROM_DATE'] || '';
            let knowledgeToDate = row['KNOWLEDGE_TO_DATE'] || '';
            let viewFromDate = row['VIEW_FROM_DATE'] || '';
            let viewToDate = row['VIEW_TO_DATE'] || '';
            let categoryCd = row['CATEGORY_CD'] || '';
            let categoryNm = row['CATEGORY_NM_CNV'] || '';
            let corpNo = row['CORP_NO'] || '';
            let contentType = row['CONTENT_CD'] || '';
            
            if(! SDLUtil.isNull(categoryCd) ) {
                SDLUtil.show(
                    KnowledgeCategoryPop,
                    {   knowledgeFromDate: knowledgeFromDate,
                        knowledgeToDate: knowledgeToDate,
                        viewFromDate: viewFromDate,
                        viewToDate: viewToDate,
                        corpNo: corpNo,
                        contentType: contentType,
                        categoryCd: categoryCd,
                        categoryNm: categoryNm,
                    },
                    { height: 'auto' }
                );
            }
        },
        excelDownload() {
            let validContents = this.registVerifyContents();
            if(validContents) {
                SDLUtil.confirm({
                    msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                    onOkEvt: () => {
                        SDLUtil.showLoadingBar(true);
                        const mFormat = localStorage.getItem('mDateFormat');
                        return axios
                            .post(
                                `${SDLUtil.API_URL}/basis/admin/statisticsManager/statisticsManagerContentsSatisfactionNewListExcel.skp`,
                                qs.stringify({
                                    RHQCD               : this.selectRhqCd,
                                    RHQSUBCD            : this.selectRhqSubCd,
                                    CONTENTTYPE         : this.selectContentType,
                                    PROPERTY            : this.selectProperty,
                                    PRD_CATEGORY_CD1    : this.PRD_CATEGORY_CD1,
                                    PRD_CATEGORY_CD2    : this.PRD_CATEGORY_CD2,
                                    PRD_CATEGORY_CD3    : this.PRD_CATEGORY_CD3,
                                    KNOWLEDGE_FROM_DATE : this.knowledgeRangePicker.getStartDate() ? moment(this.knowledgeRangePicker.getStartDate()).format(mFormat) : '',
                                    KNOWLEDGE_TO_DATE   : this.knowledgeRangePicker.getEndDate() ? moment(this.knowledgeRangePicker.getEndDate()).format(mFormat) : '',
                                    VIEW_FROM_DATE      : this.viewRangePicker.getStartDate() ? moment(this.viewRangePicker.getStartDate()).format(mFormat) : '',
                                    VIEW_TO_DATE        : this.viewRangePicker.getEndDate() ? moment(this.viewRangePicker.getEndDate()).format(mFormat) : ''
                                }),
                            )
                            .then(resp => {
                                SDLUtil.showLoadingBar(false);
                                if (resp.data.EXCEL_FILES.length > 0) {
                                    SDLUtil.show(
                                        ExcelDownloadPopup,
                                        {
                                            title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                            excelFiles: resp.data.excelFiles,
                                        },
                                        {
                                            height: 'auto',
                                        },
                                    );
                                }
                                SDLUtil.showLoadingBar(false);
                            })
                            .catch(err => {
                                Vue.$log.error(err);
                                SDLUtil.errorAlert(err);
                                SDLUtil.showLoadingBar(false);
                            });
                    },
                });
            };
        },
        registVerifyContents() {
            let validList = [''];
            
            if(SDLUtil.isNull(this.knowledgeRangePicker.getStartDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Registered period' + '</span>');
            if(SDLUtil.isNull(this.viewRangePicker.getStartDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Counting Period' + '</span>');
            
            if(validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + validList.join(''),
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        },
    },
    created() {
        // 초기 카테고리1 리스트 로드
        this.setCategory1();
    },

    mounted() {
        
        this.$nextTick(() => {
            this.getCodeComboList1(this.getLoginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data;
                    this.selectRhqCd =  this.getLoginRHQCd;
                });

            this.getCodeComboList1(this.getLoginRHQCd, "SUB_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = this.getLoginCompanyCd;
                });

            let toDate = new Date();    
            let fromDate = toDate.setMonth(toDate.getMonth() - 1);
            this.knowledgeRangePicker = DatePicker.createRangeWithOpener(
                            'knowledge-from-picker-container', 'knowledge_fromDate', 'knowledge_icoFromDate',
                            'knowledge-to-picker-container', 'knowledge_toDate', 'knowledge_icoToDate',
                            { type: 'date', locale: 'en', showToday: false },
                            (new moment()).add(-30, 'days').toDate(),
                            (new moment()).toDate()
            );
            this.viewRangePicker = DatePicker.createRangeWithOpener(
                            'view-from-picker-container', 'view_fromDate', 'view_icoFromDate',
                            'view-to-picker-container', 'view_toDate', 'view_icoToDate',
                            { type: 'date', locale: 'en', showToday: false },
                            (new moment()).add(-30, 'days').toDate(),
                            (new moment()).toDate()
            );

        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
    /*  사용시 해당 컨포넌트에서만 사용 */
.zindex9999 { z-index: 99999999; }
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
.top20 {top: -20px;}
.float-none {float: none;}
.ftColor { color: dodgerblue!important; font-weight: bold!important; }
.sub_total {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 40px !important;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/contentsSatisfactionNewList.vue